
import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import { CardFormHorizontalThird } from '../../widgets/Cards';
import { editPainHistory, newPainHistory, fetchPainHistorys } from '../../../actions';

class PainHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current_entry : null
        };
    };

    componentDidMount() {
        this.props.fetchPainHistorys(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchPainHistorys(this.props.patient._id)
        }    
    }

    formButton() {
        var permit = this.props.selectedPermission.permission[0].pain;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }
    
    PainHistoryForm() { 
        const all_contents = this.props.content;
        const last_entry = all_contents[(all_contents.length)-1];
        const content = last_entry;

        const handleSubmit = (formValues) => {
            const form = formValues;

        // Change Actions below
            this.props.newPainHistory(form);
        }

        const required = value =>(value ? undefined : 'Required');

// SECTION A
        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className='header'>Pain History</div>

                            <div className='form-3-columns'>
                                <div>
                                <Field name="date" component='input' label="Date" validate={required}>
                                        {({input, meta}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Date</label>
                                                    <input {...input} type='date' />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                        )} 
                                </Field>
                                <Field name='site' component='input' validate={required} placeholder='Location of pain'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Site</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                
                                <Field name='history' component='input' validate={required} placeholder='History of this pain'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>History</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                
                                <Field name='investigation' component='input' validate={required} placeholder='Investigations performed'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Investigation</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                                <div>
                                <Field name='radiation' component='input' validate={required} placeholder='Radiation of pain'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Pain Radiation</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                <Field name='character' component='input' validate={required} placeholder='character of pain : stabbing, cramping, pin/needles, etc. '>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Language</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                <Field name='intensity' component='input' validate={required} placeholder='intensity of pain 1-10 during rest and activity'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Intensity of pain</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                
                                <Field name='altering' component='input' validate={required} placeholder='Things that can improve or worsen pain'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Altering Factors</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                <Field name='associated' component='input' validate={required} placeholder='Associated symptoms that comes with pain'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Associated symptoms</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                </div>
                                <div>
                                <Field name='temporal' component='input' validate={required} placeholder='Fluctuation of pain level according to time of the day'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Temporal factors</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                            
                                <Field name='treatment' component='input' validate={required} placeholder='Previous treatment for this pain'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Treatment</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                <Field name='medication' component='input' validate={required} placeholder='Previous and current medications for pain'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Medications</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                </Field>
                                </div>
                            </div>

                            <div className={this.formButton()}>
                                <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardFormHorizontalThird content={this.PainHistoryForm()}>
            </CardFormHorizontalThird>
        )
    }
}


const mapStateToProps = (state) => {
    return { 
             patient : state.selectedPatient,
             content : Object.values(state.pain_historys),
             userId : state.auth.userId,
             selectedPermission : state.selectedPermission,
            };
}

export default connect(mapStateToProps,{editPainHistory, newPainHistory, fetchPainHistorys})(PainHistory);
